import { render, staticRenderFns } from "./AdminOrgBrief.vue?vue&type=template&id=a95d09a2&scoped=true&"
import script from "./AdminOrgBrief.vue?vue&type=script&lang=js&"
export * from "./AdminOrgBrief.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgBrief.vue?vue&type=style&index=0&id=a95d09a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95d09a2",
  null
  
)

export default component.exports